export default __webpack_public_path__ + "static/media/5.f83c62f5.png";